import * as utils from "./misc";
import * as slick from "./plugins/slick.js";

import * as cart from "./woocommerce/cart.js";

import * as filters from "./woocommerce/filters.js";

function init_quickview() {
  jQuery("body").on("click", ".quickview", function (e) {
    e.preventDefault();
    var objProduct = jQuery(this);
    objProduct.addClass("loading");

    var productsku = objProduct.attr("data-productsku");
    var productid = objProduct.attr("data-productid");

    var template =
      `
        <div class="vc_row loading"><div class="vc_col-sm-12 text-center"><img src="` +
      base.themeurl +
      `/assets/images/ajax-loading.gif" /></div></div>
        <div class="vc_row">
        <div class="vc_col-sm-5"><div class="product_image_carousel"></div></div>
        <div class="vc_col-sm-7"><h1 class="product_title"></h1><div class="product-price-wrapper"></div><div class="product_excerpt"></div><div class="product_meta_wrapper"></div></div>
        </div>`;
    jQuery.magnificPopup.open({
      mainClass: "mfp-zoom-in",
      showCloseBtn: true,
      removalDelay: 200,
      items: {
        src:
          '<div class="productpopup_wrapper mfp-with-anim">' +
          template +
          "</div>",
        type: "inline",
      },
      callbacks: {
        open: function () {
          //load product data

          jQuery.post(
            base.ajaxurl,
            {
              action: "get_productdata",
              productsku: productsku,
              productid: productid,
            },
            function (productdata) {
              var pd = JSON.parse(productdata);
              var jQuerypopup = objProduct;
              var gallery = pd.imageGallery;
              var thumbs = pd.imageThumbGallery;

              var productURL = pd.productURL;
              console.log(jQuery(".mfp-content").find(".product-title").length);

              jQuery(".mfp-content").find(".loading").remove();
              jQuery(".mfp-content")
                .find(".product_title")
                .html(pd.productName);
              jQuery(".mfp-content")
                .find(".product-price-wrapper")
                .html(`<br />` + pd.productPrice);
              jQuery(".mfp-content")
                .find(".product_excerpt")
                .html(pd.productShortDescription);

              var cats = "";
              for (a = 0; a < pd.productCats.length; a++) {
                cats +=
                  "<a href='" +
                  pd.productCats[a].url +
                  "'>" +
                  pd.productCats[a].name +
                  "</a> ";
              }

              jQuery(".mfp-content")
                .find(".product_meta_wrapper")
                .html(pd.productmetaHTML)
                .prepend(
                  `<br /><a class='btn' href='` +
                    productURL +
                    `'>More Details</a><br /><br />`
                );

              jQuery(".close-quickview").on("click", function (e) {
                e.preventDefault();
                jQuery.magnificPopup.close();
              });
              jQuery(".viewproductbtn").on("click", function (e) {
                window.location = pd.productURL;
              });

              var mainimages = "";
              var thumbnails = "";

              jQuery("#pcarousel").html("");
              jQuery("#thumbnails").html("");

              for (var a = 0; a < gallery.length; a++) {
                mainimages +=
                  `<div class="slide-item cursor" data-itemno="` +
                  a +
                  `" ><img src="` +
                  gallery[a] +
                  `" width='500' height='500' /></div>`;
                thumbnails +=
                  `<div class="slide-item cursor" data-itemno="` +
                  a +
                  `" ><img src="` +
                  thumbs[a] +
                  `" width='100' height='100'/></div>`;
              }

              jQuery(".mfp-content")
                .find(".product_image_carousel")
                .append(
                  `<div id="popup-mainimages" data-slidestoshow="1"
                        data-slidestoshow-md="1"
                        data-slidestoshow-sm="2"
                            data-centermode="true"
                            data-centerpadding="0"
                            data-focusonselect="true"
                            data-fade="false"
                            data-autoplay="true"
                            data-arrows="true"
                            data-adaptiveheight="false"
                            data-asnavfor=".product-thumbnails"
                            class='product_image slick-slider arrows-style-belowright'>` +
                    mainimages +
                    "</div>"
                );

              jQuery(".mfp-content")
                .find(".product_image_carousel")
                .append(
                  `<div id="popup-thumbnails" class="product-thumbnails pts slick-slider" 
                            data-slidestoshow="3"
                            data-slidestoshow-md="3"
                            data-slidestoshow-sm="3"
                            data-centermode="true"
                            data-centerpadding="0"
                            data-focusonselect="true"
                            data-fade="false"
                            data-autoplay="true"
                            data-autoplayspeed="5000"
                            data-transitionspeed="500"
                            data-adaptiveheight="false"
                            data-asnavfor=".product_image"
                        >` +
                    thumbnails +
                    `</div>`
                );

              setTimeout(function () {
                jQuerypopup.addClass("animate-width");
              }, 500);
              setTimeout(function () {
                init_carousel();
              }, 1000);
            }
          );
        },
      },
    });
    return false;
  });
}

function addtocart(thisel) {
  var prodid = thisel.attr("data-product_id");
  var qty = thisel.siblings(".quantity input[name='quantity']").val() || 1;
  thisel.html("...adding");
  var data = {
    action: "woocommerce_ajax_add_to_cart",
    product_id: prodid,
    product_sku: "",
    quantity: qty,
    variation_id: "",
  };

  jQuery.ajax({
    type: "post",
    url: base.ajaxurl,
    data: data,
    beforeSend: function (response) {
      thisel.removeClass("added").addClass("loading");
    },
    complete: function (response) {
      thisel.addClass("added").removeClass("loading");
    },
    success: function (response) {
      thisel.html("added!");

      if (response.error && response.product_url) {
        window.location = response.product_url;
        return;
      } else {
        jQuery(document.body).trigger("added_to_cart", [
          response.fragments,
          response.cart_hash,
          thisel,
        ]);
      }
    },
  });

  return false;
}

export function init() {
  //console.log("woo init")
  //single.init();
  // wishlist.init();
  filters.init();
  cart.init();
  //gtm.init();

  //init_quickview();
  check_productreview();

  jQuery(document.body).on("updated_cart_totals", function () {
    cart.refreshCart();
  });

  jQuery("body").on("click", ".ajax_add_to_cart", function () {
    addtocart(jQuery(this));
  });

  jQuery(".related.products .products").each(function (index, el) {
    if (!jQuery(this).hasClass("slick-initialized")) {
      jQuery(this).addClass("slick-slider").addClass("arrows-style-belowright");
      jQuery(this).attr("data-arrows", "true");
      jQuery(this).attr("data-arrows", "true");
    }
  });

  jQuery(".cross-sells .products").each(function (index, el) {
    if (!jQuery(this).hasClass("slick-initialized")) {
      jQuery(this).addClass("slick-slider").addClass("arrows-style-belowright");
      jQuery(this).attr("data-autoplay", "true");
      jQuery(this).attr("data-arrows", "true");
      jQuery(this).attr("data-slidestoshow-sm", "1");
      jQuery(this).attr("data-slidestoshow-md", "4");
      jQuery(this).attr("data-slidestoshow", "4");

      slick.init();
    }
  });

  jQuery(".up-sells .products").each(function (index, el) {
    if (!jQuery(this).hasClass("slick-initialized")) {
      jQuery(this).addClass("slick-slider").addClass("arrows-style-belowright");
      jQuery(this).attr("data-autoplay", "true");
      jQuery(this).attr("data-arrows", "true");
      jQuery(this).attr("data-slidestoshow-sm", "1");
      jQuery(this).attr("data-slidestoshow-md", "4");
      jQuery(this).attr("data-slidestoshow", "4");
      slick.init();
    }
  });

  // init_carousel();

  jQuery(".starreviews").on("click", function () {
    jQuery(".woocommerce-tabs .wc-tabs .reviews_tab a").trigger("click");
    utils.scrollTo(".woocommerce-tabs", 0);
  });

  jQuery(".result-count").html(jQuery(".woocommerce-result-count").html());

  /*****SINGLE PRODUCT PAGE */

  //show popup on add to cart
  jQuery("body").on("added_to_cart", function () {
    var crosssells = jQuery(".crosssells.products #crosssell-owl").clone();
    var productname = jQuery(".product_title").html();

    var newowl = "";
    crosssells.find("li").each(function () {
      var thisli = "<li class='product'>" + jQuery(this).html() + "</li>";
      newowl += thisli;
    });

    var owlsrc =
      newowl != ""
        ? `<br /><h4>Don't forget to take a look at these...<br /></h4><ul class="slick-slider products columns-4" id="crosssell-slider"  data-itemmargin="10" data-itemssm="1" data-itemsmd="4" data-itemslg="4"  data-loop="true" data-infinite="true" data-autoplay="true" data-navigation="true">` +
          newowl +
          `</ul>`
        : "";
    var popupsrc =
      `<div class="mfp-with-anim"><div class="addedtobasketpopup"><h2 class="blue">` +
      productname +
      ` has been added to your basket!</h2>` +
      owlsrc +
      `<div class="text-center"><a href="/cart" class=" btn btn-primary">View Your Basket</a><br /><br /></div><br /></div></div>`;

    jQuery.magnificPopup.open({
      items: {
        src: popupsrc,
        type: "inline",
      },
      callbacks: {
        open: function () {
          // init_carousel();
          console.log("//added to cart callback");
        },
      },
    });
  });

  // jQuery("body").on("click", ".btn-addtocart", function () {
  //     var thisbtn = jQuery(this);
  //     var productid = thisbtn.attr("data-productid");

  //     str = `<div id="loadingcontainer">
  //                     <div id="ball-1" class="circle"></div>
  //                     <div id="ball-2" class="circle"></div>
  //                     <div id="ball-3" class="circle"></div>
  //                 <div>`;
  //     jQuery(this).html("");
  //     jQuery(str).appendTo(this);

  //     jQuery.post(base.ajaxurl, {
  //         action: "addtocart",
  //         productid: productid

  //     }, function (r) {
  //         var r = JSON.parse(r);

  //         if (r.error == "notloggedin") {
  //             showloginpopup();
  //         }
  //         else if (r.success == true) {
  //             thisbtn.html("<a href='/cart' class='btn'>Added ! Click here to view your cart</a>").removeClass("btn-addtocart");
  //             // user.get_user(true);
  //         }
  //     })
  // })

  jQuery(".input-radio", "#payment").on("change", function () {
    var val = jQuery(".input-radio:checked", "#payment").val();
    jQuery(".payment_box", "#payment").hide();
    jQuery(".payment_method_" + val, "#payment ").show();
  });
}

function check_productreview() {
  var tab = utils.getParameterByName("tab");

  if (tab == "review") {
    gotoreviews();
  }
}

function gotoreviews() {
  jQuery(".reviews_tab a").trigger("click");
  page.scrollTo(".reviews_tab", 150);
}

function do_coupon(coupon_code) {
  jQuery.post(
    base.ajaxurl,
    {
      action: "apply_coupon",
      coupon_code: coupon_code,
    },
    function (r) {
      var r = JSON.parse(r);
      jQuery(".couponresult").remove();
      if (r.applied) {
        jQuery(
          "<div class='couponresult'>Your coupon has been applied</div>"
        ).insertAfter(".coupon");
        jQuery("form.woocommerce-cart-form").submit();
      } else if (r.loggedin) {
        jQuery(
          "<div class='couponresult'>There was a problem with that coupon</div>"
        ).insertAfter(".coupon");
      }
    }
  );
}
